import { configureStore } from '@reduxjs/toolkit';
import userSlice from './slice/userSlice';
import masterReducer from './slice/masterSlice';
import loaderReducer from './slice/loaderSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, 
  FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { combineReducers } from 'redux';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user','master'],
};

const rootReducer = combineReducers({
  user: userSlice,
  loader: loaderReducer,
  master: masterReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
